import React from 'react'
import Navbar from '../components/navbar'
import Hero from '../components/hero'
import NewArival from '../components/newArival'
import UseFetch from '../hooks/useFetch'
import Products from '../components/products'
import { useNavigate } from 'react-router-dom'

function Home() {
  const {data,getData} = UseFetch();
  const navigate = useNavigate()
  const onsendHandler =()=>{
    navigate('/shop')
    
  }
  return (
    <div>
      <Navbar/>
      <Hero onClickHandler={onsendHandler}/>
      <NewArival/>
      {/* <Products/> */}
    </div>
  )
}

export default Home
